/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  overallQuickMessageReport: [],
  overallAPIQuickMessageReport: [],
  overallReportCount: {},
  overallReportData: [],
  reportAnalyticsData: [],
  allMessageData: [],
  campaignReplies: {},
  singleMessageData: {},
  reportId: '',
  optoutTableData: [],
  optoutSurveyData: [],
  optoutLineData: [],
  shortLinkSurvey: [],
  shortlinkLineGraph: [],
  shortlinkPieGraph: [],
  bouncedMessageData: [],
  leadGenrationData: [],
  contactList: [],
  ipInfo: {},
  isLoadBulkContactList: false,
}

export const getLeadGenrationData: any = createAsyncThunk(
  'getLeadGenrationData',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getLeadGenarationReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const getLeadGenrationExport: any = createAsyncThunk(
  'getLeadGenrationExport',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getLeadGenarationReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const getAllReportOverviewCount: any = createAsyncThunk(
  'getAllReportOverviewCount',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getActivityOverviewCount`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getQuickMsgReport: any = createAsyncThunk(
  'getQuickMsgReport',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/allQuikMessageListReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getAPIQuickMsgReport: any = createAsyncThunk(
  'getAPIQuickMsgReport',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/allQuikAPIMessageListReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getAllReportOverview: any = createAsyncThunk(
  'getAllReportOverview',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getActivityOverviewGraph`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const getAllReportOverviewExport: any = createAsyncThunk(
  'getAllReportOverviewExport',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getActivityOverviewGraph`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const getAllMessageReport: any = createAsyncThunk(
  'getAllMessageReport',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}report/allCampaignListReport`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getAllBouncedMessageData: any = createAsyncThunk(
  'getAllBouncedMessageData',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignBounceReportDetails/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const exportAllBouncedMessageData: any = createAsyncThunk(
  'exportAllBouncedMessageData',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignBounceReportDetails/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getCampaignReplies: any = createAsyncThunk(
  'getCampaignReplies',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerReplies/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getSingleMessageReport: any = createAsyncThunk(
  'getSingleMessageReport',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getCampaignReportDetails/${data?.id}`, {
      params: data.params,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getOptoutSurveyGraph: any = createAsyncThunk(
  'getOptoutSurveyGraph',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerOptoutGraph/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getOptoutLineData: any = createAsyncThunk(
  'getOptoutLineData',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerOptoutLineGraph/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getOptoutTableReport: any = createAsyncThunk(
  'getOptoutTableReport',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerOptout/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getDataOfClickthroughTable: any = createAsyncThunk(
  'getDataOfClickthroughTable',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerClicksList/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getDataOfClickthroughLineChart: any = createAsyncThunk(
  'getDataOfClickthroughLineChart',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerClicksLineChart/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getCampaginContactsList: any = createAsyncThunk(
  'getCampaginContactsList',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getCampaignReportContactList/${data?.id}`, {
      params: data?.params,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const exportCampaignContactsList: any = createAsyncThunk(
  'exportCampaignContactsList',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}report/getCampaignReportContactList/${data?.id}`, {
      params: data?.params
        ? {
            ...data.params,
            export: true,
          }
        : {export: true},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getDataOfClickthroughPieChart: any = createAsyncThunk(
  'getDataOfClickthroughPieChart',
  async (data: any, thunkApi) => {
    const response = await axios.get(
      `${API_URL}report/getCampaignReportCustomerClicksPiaChart/${data?.id}`,
      {
        params: data?.params,
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const getIPInfo: any = createAsyncThunk('getIPInfo', async (data: any, thunkApi) => {
  const response = await axios.get(`https://www.iplocate.io/api/lookup/${data}`)
  thunkApi.dispatch(stopLoading())
  return response.data
})

const reportAnalyticsSlice: any = createSlice({
  name: 'reportAnalyticsSlice',
  initialState,
  reducers: {
    storeReportId: (state: any, {payload}) => {
      return {...state, reportId: payload}
    },
    setIsLoadBulkContactList: (state: any, {payload}) => {
      return {...state, isLoadBulkContactList: payload}
    },
    storeSchedulerId: (state: any, {payload}) => {
      return {...state, schedulerId: payload}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSingleMessageReport.fulfilled, (state, action) => {
      return {...state, singleMessageData: action?.payload}
    })
    builder.addCase(getAllMessageReport.fulfilled, (state, action) => {
      return {...state, allMessageData: action?.payload}
    })
    builder.addCase(getCampaignReplies.fulfilled, (state, action) => {
      return {...state, campaignReplies: action?.payload}
    })
    builder.addCase(getOptoutTableReport.fulfilled, (state, action) => {
      return {...state, optoutTableData: action?.payload}
    })
    builder.addCase(getOptoutSurveyGraph.fulfilled, (state, action) => {
      return {...state, optoutSurveyData: action?.payload}
    })
    builder.addCase(getOptoutLineData.fulfilled, (state, action) => {
      return {...state, optoutLineData: action?.payload}
    })
    builder.addCase(getDataOfClickthroughTable.fulfilled, (state, action) => {
      return {...state, shortLinkSurvey: action?.payload}
    })
    builder.addCase(getDataOfClickthroughLineChart.fulfilled, (state, action) => {
      return {...state, shortlinkLineGraph: action?.payload}
    })
    builder.addCase(getDataOfClickthroughPieChart.fulfilled, (state, action) => {
      return {...state, shortlinkPieGraph: action?.payload}
    })
    builder.addCase(getAllBouncedMessageData.fulfilled, (state, action) => {
      return {...state, bouncedMessageData: action?.payload}
    })
    builder.addCase(getAllReportOverviewCount.fulfilled, (state, action) => {
      return {...state, overallReportCount: action?.payload}
    })
    builder.addCase(getAllReportOverview.fulfilled, (state, action) => {
      return {...state, overallReportData: action?.payload}
    })
    builder.addCase(getQuickMsgReport.fulfilled, (state, action) => {
      return {...state, overallQuickMessageReport: action?.payload}
    })
    builder.addCase(getAPIQuickMsgReport.fulfilled, (state, action) => {
      return {...state, overallAPIQuickMessageReport: action?.payload}
    })
    builder.addCase(getLeadGenrationData.fulfilled, (state, action) => {
      return {...state, leadGenrationData: action?.payload}
    })
    builder.addCase(getCampaginContactsList.fulfilled, (state, action) => {
      return {...state, contactList: action?.payload, isLoadBulkContactList: false}
    })
    builder.addCase(getIPInfo.fulfilled, (state, action) => {
      return {...state, ipInfo: action?.payload}
    })
  },
})

export const {storeReportId, setIsLoadBulkContactList, storeSchedulerId} =
  reportAnalyticsSlice.actions

export const GetOverAllReportCount = (state: any) =>
  state?.reportAnalytics?.overallReportCount?.data
export const GetLeadGenrationReport = (state: any) =>
  state?.reportAnalytics?.leadGenrationData?.data
export const GetQickMsgReport = (state: any) =>
  state?.reportAnalytics?.overallQuickMessageReport?.data
export const GetAPIQickMsgReport = (state: any) =>
  state?.reportAnalytics?.overallAPIQuickMessageReport?.data
export const GetOverAllReportData = (state: any) => state?.reportAnalytics?.overallReportData?.data
export const GetReportId = (state: any) => state?.reportAnalytics?.reportId
export const GetCampaignRepliesData = (state: any) => state?.reportAnalytics?.campaignReplies
export const GetOptOutSurveyData = (state: any) => state?.reportAnalytics?.optoutSurveyData?.data

export const GetOptOutLineData = (state: any) => state?.reportAnalytics?.optoutLineData
export const GetOptOutTableData = (state: any) => state?.reportAnalytics?.optoutTableData
export const GetClickThroughData = (state: any) => state?.reportAnalytics?.shortLinkSurvey?.data
export const GetClickThroughlineChart = (state: any) =>
  state?.reportAnalytics?.shortlinkLineGraph?.data
export const GetClickThroughPieChart = (state: any) =>
  state?.reportAnalytics?.shortlinkPieGraph?.data
export const GetAllMessageData = (state: any) => state?.reportAnalytics?.allMessageData?.data
export const GetSingleMessageData = (state: any) =>
  state?.reportAnalytics?.singleMessageData?.data?.[0]
export const GetBouncedData = (state: any) => state?.reportAnalytics?.bouncedMessageData?.data
export const GetContactListOfCampaign = (state: any) => state?.reportAnalytics?.contactList?.data
export const GetIpData = (state: any) => state?.reportAnalytics?.ipInfo
export const IsLoadBulkContactList = (state: any) => state?.reportAnalytics?.isLoadBulkContactList
export const GetSchedulerReportId = (state: any) => state?.reportAnalytics?.schedulerId

export default reportAnalyticsSlice.reducer
